import { Logo } from "./styles";
import { Link } from "react-router-dom";
import { useAppLogoAsset } from "@shared/hooks/useAppLogoAsset";

export const NavbarLogo = () => {
  const { src, alt, isRadarDomain } = useAppLogoAsset("white");

  return (
    <Logo $imgHeight={isRadarDomain ? "32px" : undefined}>
      <Link to="/">
        <img src={src} alt={alt} />
      </Link>
    </Logo>
  );
};
